import LineVisualization from "views/components/visualizations/line/LineVisualization";
import LineVisualizationConfig from "views/logic/aggregationbuilder/visualizations/LineVisualizationConfig";
import { hasAtLeastOneMetric } from "views/components/visualizations/validations";
import {
  DEFAULT_AXIS_CONFIG,
  DEFAULT_AXIS_TYPE,
  axisTypes
} from "views/logic/aggregationbuilder/visualizations/XYVisualization";
import { DEFAULT_INTERPOLATION, interpolationTypes } from "views/Constants";
import xyAxisConfigFields, { fromAxisConfig } from "views/components/visualizations/xyAxisConfigFields";
const validate = hasAtLeastOneMetric("Line chart");
const lineChart = {
  type: LineVisualization.type,
  displayName: "Line Chart",
  component: LineVisualization,
  config: {
    createConfig: () => ({
      interpolation: DEFAULT_INTERPOLATION,
      axisType: DEFAULT_AXIS_TYPE,
      axisConfig: DEFAULT_AXIS_CONFIG
    }),
    fromConfig: (config) => {
      var _a, _b;
      return {
        interpolation: (_a = config == null ? void 0 : config.interpolation) != null ? _a : DEFAULT_INTERPOLATION,
        axisType: (_b = config == null ? void 0 : config.axisType) != null ? _b : DEFAULT_AXIS_TYPE,
        ...fromAxisConfig(config)
      };
    },
    toConfig: (formValues) => LineVisualizationConfig.create(
      formValues.interpolation,
      formValues.axisType,
      formValues.showAxisLabels ? formValues.axisConfig : DEFAULT_AXIS_CONFIG
    ),
    fields: [
      {
        name: "interpolation",
        title: "Interpolation",
        type: "select",
        options: interpolationTypes,
        required: true
      },
      {
        name: "axisType",
        title: "Axis Type",
        type: "select",
        options: axisTypes,
        required: true
      },
      ...xyAxisConfigFields
    ]
  },
  capabilities: ["event-annotations"],
  validate
};
export default lineChart;
